const getRuntimeConfig = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__APP_CONFIG__ || {};
};

const runtimeConfig = getRuntimeConfig();

export const APP_CONFIG = {
  API_URL: runtimeConfig.API_URL || process.env.REACT_APP_API_URL || 'http://localhost:3003',
  MUNICIPALITY_NAME: runtimeConfig.MUNICIPALITY_NAME || process.env.REACT_APP_MUNICIPALITY_NAME || 'Cruzeiro do Sul',
  APP_NAME: runtimeConfig.APP_NAME || process.env.REACT_APP_APP_NAME || 'SIAPESUS',
  APP_TITLE: runtimeConfig.APP_TITLE || process.env.REACT_APP_APP_TITLE || '',
  SIDEBAR_TITLE: runtimeConfig.SIDEBAR_TITLE || process.env.REACT_APP_SIDEBAR_TITLE || '',
  FOOTER_TEXT: runtimeConfig.FOOTER_TEXT || process.env.REACT_APP_FOOTER_TEXT || 'SIAPESUS',
  DESCRIPTION:
    runtimeConfig.DESCRIPTION ||
    process.env.REACT_APP_DESCRIPTION ||
    'Sistema de gestão e faturamento do SUS',
  VERSION: runtimeConfig.VERSION || process.env.REACT_APP_VERSION || '1.0.0'
};

export const getAppTitle = () => (
  APP_CONFIG.APP_TITLE || `${APP_CONFIG.MUNICIPALITY_NAME} - ${APP_CONFIG.APP_NAME}`
);

export const getSidebarTitle = () => (
  APP_CONFIG.SIDEBAR_TITLE || `${APP_CONFIG.MUNICIPALITY_NAME} - I9 SUS`
);

export const getAppVersion = () => APP_CONFIG.VERSION;

export default APP_CONFIG;
